module.exports = __webpack_public_path__ + "910c0fb3440a800691cbbe0b6ebe3e91.svg";